/**
 * Shopify embedded-app helpers — no App Bridge dependency.
 *
 * App Bridge v3 caused two hard bugs:
 *  1. Static imports run at module-evaluation time, before React Router mounts
 *     → throws a React Router 404 during render
 *  2. NavigationMenu.create sends destinations to Shopify Admin; Shopify Admin
 *     navigates its own frame to those paths → Shopify Admin 404
 *
 * The custom sidebar already handles in-app navigation.
 * eBay OAuth uses a programmatic target="_top" anchor which works cross-origin.
 */

export function isEmbedded() {
  try { return window.self !== window.top } catch { return true }
}

export function getHost() {
  return new URLSearchParams(window.location.search).get('host') || ''
}

/**
 * Navigate the top-level browser window to an external URL.
 * Works cross-origin from within a Shopify Admin iframe via target="_top".
 */
export function redirectExternal(url) {
  const a = document.createElement('a')
  a.href   = url
  a.target = '_top'
  a.rel    = 'noopener noreferrer'
  document.body.appendChild(a)
  a.click()
  document.body.removeChild(a)
}
